export default "__VITE_ASSET__UuXPPDIe__"